export enum Strategies {
  court = 'court',
}
